import { FC, useMemo } from "react";
import ReactPaginate from "react-paginate";

import { getTranslations } from "../utils";

interface Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const SearchPager: FC<Props> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handleChangePage = (selectedItem: { selected: number }) => {
    onPageChange(selectedItem.selected + 1);
  };

  const previousLabel = useMemo(
    () => getTranslations("searchPaginationPreviousLabel"),
    []
  );
  const nextLabel = useMemo(
    () => getTranslations("searchPaginationNextLabel"),
    []
  );

  return (
    <div className="search-pager pager">
      <ReactPaginate
        containerClassName="pager__items"
        breakClassName="pager__item"
        pageClassName="pager__item"
        activeClassName="is-active"
        previousClassName="pager__item--previous"
        previousLabel={previousLabel}
        nextClassName="pager__item--next"
        nextLabel={nextLabel}
        pageCount={Math.ceil(totalPages)}
        initialPage={currentPage}
        forcePage={currentPage}
        disableInitialCallback
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        onPageChange={handleChangePage}
      />
    </div>
  );
};
